module.exports = __webpack_public_path__ + "img/compare2.4643a590.png";